import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../../../../utils/OggettiUtili.json";
import styles from "../../DatiSpecifici/DatiSpecifici.module.css";
import Autocomplete from "../../../../../components/autocomplete/Autocomplete";
import Input from "../../../../../components/textbox/Input";
import Calendar from "../../../../../components/calendar/Calendar";
import Utils from "../../../../../utils/Utils";
import SelectAutocomplete from "../../../../../components/selectAutocomplete/SelectAutocomplete";
import SessioneUtente from "../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../utils/Ruoli";

class Parte1A extends Component {

    state = {
        parte1A: {
            regione: "",
            ulss: "",
            centro: "",
            nome: "",
            cognome: "",
            dataDiNascita: "",
            comuneResidenza: "",
            comuneDomicilio: ""
        },
        regioni: OggettiUtili.Regioni,
        arrayUlss: [],
        comuni: JSON.parse(sessionStorage.getItem("comuni")),
        comuniPerCodice: JSON.parse(sessionStorage.getItem("comuniPerCodice")),
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.controlloDati = this.controlloDati.bind(this)
        this.createObjectBE = this.createObjectBE.bind(this)
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        let arrayUlss = this.state.arrayUlss
        Object.keys(OggettiUtili.ulssMap).map((key) => {
            arrayUlss.push(OggettiUtili.ulssMap[key]);
            return arrayUlss
        });
        let parte1A = this.state.parte1A
        let parte1ACopia = this.props.segnalazioneCopia.esitoTbcPolmonare && this.props.segnalazioneCopia.esitoTbcPolmonare.parte1A ?
            this.props.segnalazioneCopia.esitoTbcPolmonare.parte1A : ""
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.esitoTbcPolmonare && parte1ACopia) {
            for (let key in parte1A) {
                if (parte1A.hasOwnProperty(key) === parte1ACopia.hasOwnProperty(key)) {
                    if (key === "ulss") {
                        parte1A[key] = OggettiUtili.ulssMap[parte1ACopia[key]] && OggettiUtili.ulssMap[parte1ACopia[key]].codice ? OggettiUtili.ulssMap[parte1ACopia[key]].codice : ""
                    } else if (key === "comuneResidenza" || key === "comuneDomicilio") {
                        parte1A[key] = this.state.comuniPerCodice[parte1ACopia[key]]
                    } else if (key === "dataDiNascita") {
                        parte1A[key] = Utils.transformDateForFrontend(parte1ACopia[key])
                    } else {
                        parte1A[key] = parte1ACopia[key]
                    }
                } else {
                    parte1A[key] = ""
                }
            }
        } else if (this.props.datiPaziente) {
            parte1A.nome = this.props.datiPaziente.nomePaziente
            parte1A.cognome = this.props.datiPaziente.cognomePaziente
            parte1A.dataDiNascita = this.props.datiPaziente.dataDiNascita
            parte1A.comuneDomicilio = this.props.datiPaziente.comuneDomicilio
            parte1A.comuneResidenza = this.props.datiPaziente.comuneResidenza
            parte1A.ulss = this.props.segnalazioneCopia.ulssSegnalazione
        }
        parte1A.regione = this.state.regioni["050"]
        this.setState({arrayUlss: arrayUlss, parte1A: parte1A})
        let oggettoBE = this.createObjectBE()
        let corretto = this.controlloDati()
        this.props.createOggettoBeAndcontrolloCorrettezza("parte1A", oggettoBE, corretto)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.disabledSelectAutocomplete()
    }

    disabledSelectAutocomplete() {
        let condizione = (this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || this.props.segnalazioneDatiSpecificiCopia && (this.props.segnalazioneDatiSpecificiCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
            this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)
        Utils.disabledSelectAutocomplete(condizione)
    }

    validate() {
        if (this.state.parte1A.dataDiNascita && Utils.validateDate(this.state.parte1A.dataDiNascita, "Messages.DataNascita", "Messages.DataNascitaOdierna")) {
            return Utils.validateDate(this.state.parte1A.dataDiNascita, "Messages.DataNascita", "Messages.DataNascitaOdierna")
        }
        return ""
    }

    riceviValore(field, event) {
        let parte1A = this.state.parte1A
        parte1A[field] = event.target.value
        this.setState({parte1A: parte1A})
        let oggettoBE = this.createObjectBE()
        let corretto = this.controlloDati()
        this.props.createOggettoBeAndcontrolloCorrettezza("parte1A", oggettoBE, corretto, this.validate())
    }

    controlloDati() {
        let parte1A = this.state.parte1A
        let corretto = []

        if (!parte1A.dataDiNascita || (parte1A.dataDiNascita && Utils.isDateInValid(Utils.transformDateForBackend(parte1A.dataDiNascita), "-"))) corretto[0] = "Campo \"Data di nascita\" mancante o errato";
        if (!parte1A.regione) corretto[1] = "Campo \"Regione\" mancante";
        if (!parte1A.cognome) corretto[2] = "Campo \"Cognome\" mancante";
        if (!parte1A.nome) corretto[3] = "Campo \"Nome\" mancante";
        if (!parte1A.centro) corretto[4] = "Campo \"Centro\" mancante";

        return corretto
    }

    createObjectBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.parte1A))
        oggettoBE.dataDiNascita = Utils.transformDateForBackend(oggettoBE.dataDiNascita)
        oggettoBE.regione = (oggettoBE.regione && oggettoBE.regione.codice) ? oggettoBE.regione.codice : oggettoBE.regione
        oggettoBE.ulss = oggettoBE.ulss && oggettoBE.ulss.codice ? oggettoBE.ulss.codice : oggettoBE.ulss
        oggettoBE.comuneResidenza = (oggettoBE.comuneResidenza && oggettoBE.comuneResidenza.codice) ? oggettoBE.comuneResidenza.codice : oggettoBE.comuneResidenza
        oggettoBE.comuneDomicilio = (oggettoBE.comuneDomicilio && oggettoBE.comuneDomicilio.codice) ? oggettoBE.comuneDomicilio.codice : oggettoBE.comuneDomicilio
        let res = Utils.removeEmptyValueFromObject(oggettoBE)
        return res
    }

    render() {

        const {t} = this.props
        const datiDelCentro = (
            <div>
                <div className={"row"}>
                    <div className={"col-lg-2"}>
                        <p className={styles.testo} style={{color: "black", fontWeight: "bold"}}>
                            {t("SchedaSpecialeTbcPolmonare.regione")}
                            <span className={styles.mandatoryColor}>*</span>
                        </p>
                    </div>
                    <div className={"col-lg-6"}>
                        <Autocomplete
                            id={"idRegione"}
                            onChange={this.riceviValore}
                            field={"regione"}
                            keyField={"codice"}
                            descriptionField={"descrizione"}
                            suggestionField={"descrizione"}
                            value={this.state.parte1A.regione}
                            suggestions={this.state.regioni}
                            disabled={true}
                            placeholder={t("SchedaSpecialeTbcPolmonare.regione")}
                        >
                        </Autocomplete>
                    </div>

                </div>
                <div className={"row"} style={{marginTop: "2rem"}}>
                    <div className={"col-lg-2"}>
                        <p className={styles.testo} style={{color: "black", fontWeight: "bold"}}>
                            {t("SchedaSpecialeTbcPolmonare.ulss")}</p>
                    </div>
                    <div className={"col-lg-6"}>
                        <div style={{height: "5px"}}>
                            <SelectAutocomplete
                                id={"ulss"}
                                field={"ulss"}
                                newSelect={true}
                                disabled={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                SessioneUtente.getInstance().ruoliUtente !== Ruoli.Operatore_Regionale.descrizione
                                || this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice}
                                value={this.state.parte1A.ulss}
                                onChange={this.riceviValore}
                                functionMap={Utils.mapToArray(this.state.arrayUlss).map((oggetto) => {
                                    return (
                                        <option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}
                            >
                            </SelectAutocomplete>
                        </div>
                    </div>

                </div>
                <div className={"row"} style={{marginTop: "2rem"}}>
                    <div className={"col-lg-2"}>
                        <p className={styles.testo} style={{color: "black", fontWeight: "bold"}}>
                            {t("SchedaSpecialeTbcPolmonare.centro")}
                            <span className={styles.mandatoryColor}>*</span>
                        </p>
                    </div>
                    <div className={"col-lg-6"}>
                        <div style={{height: "5px"}}>
                            <Input
                                id={"centro"}
                                onChange={this.riceviValore}
                                field={"centro"}
                                value={this.state.parte1A.centro}
                                placeholder={t("SchedaSpecialeTbcPolmonare.centro")}
                            >
                            </Input>
                        </div>
                    </div>

                </div>
            </div>
        )

        const datiAnagrafici = (
            <div style={{marginTop: "1rem"}}>
                <div className={"row"}>
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                        <p className={styles.testo}>
                            {t("SchedaSpecialeTbcPolmonare.cognome")}
                            <span className={styles.mandatoryColor}>*</span>
                        </p>
                        <Input
                            id={"cognome"}
                            onChange={this.riceviValore}
                            field={"cognome"}
                            value={this.state.parte1A.cognome}
                            placeholder={t("SchedaSpecialeTbcPolmonare.cognome")}
                        >
                        </Input>
                    </div>
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                        <p className={styles.testo}>
                            {t("SchedaSpecialeTbcPolmonare.nome")}
                            <span className={styles.mandatoryColor}>*</span>
                        </p>
                        <Input
                            id={"nome"}
                            onChange={this.riceviValore}
                            field={"nome"}
                            value={this.state.parte1A.nome}
                            placeholder={t("SchedaSpecialeTbcPolmonare.nome")}
                        >
                        </Input>
                    </div>
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                        <p className={styles.testo}>
                            {t("SchedaSpecialeTbcPolmonare.dataDiNascita")}
                            <span className={styles.mandatoryColor}>*</span>
                        </p>
                        <Calendar id={"dataDiNascita"}
                                  value={this.state.parte1A.dataDiNascita}
                                  field={"dataDiNascita"}
                                  onChange={this.riceviValore}
                                  newCalendar={true}
                                  errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                      t("SchedaSpecialeTbcPolmonare.dataDiNascita"))}
                                  error={(!this.state.parte1A.dataDiNascita) ? false : Utils.isDateInValid(Utils.transformDateForBackend(this.state.parte1A.dataDiNascita), "-")}
                        >
                        </Calendar>
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                        <p className={styles.testo}>{t("SchedaSpecialeTbcPolmonare.comuneResidenza")}</p>
                        <div className={styles.fieldContainer}>

                            <Autocomplete
                                id={"comuneResidenza"}
                                onChange={this.riceviValore}
                                field={"comuneResidenza"}
                                keyField={"codice"}
                                descriptionField={"descrizione"}
                                suggestionField={"descrizione"}
                                value={this.state.parte1A.comuneResidenza}
                                suggestions={this.state.comuni}
                                // disabled={true}
                                placeholder={t("SchedaSpecialeTbcPolmonare.comuneResidenza")}
                            />
                        </div>
                    </div>
                    <div className={"col-lg-4"} style={{marginTop: "3rem"}}>
                        <p style={{textAlign: "center"}}>{t("SchedaSpecialeTbcPolmonare.oppure")}</p>
                    </div>
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                        <p className={styles.testo}>{t("SchedaSpecialeTbcPolmonare.comuneDomicilio")}</p>
                        <div className={styles.fieldContainer}>

                            <Autocomplete
                                id={"comuneDomicilio"}
                                onChange={this.riceviValore}
                                field={"comuneDomicilio"}
                                keyField={"codice"}
                                descriptionField={"descrizione"}
                                suggestionField={"descrizione"}
                                value={this.state.parte1A.comuneDomicilio}
                                suggestions={this.state.comuni}
                                // disabled={true}
                                placeholder={t("SchedaSpecialeTbcPolmonare.comuneDomicilio")}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )

        return (
            <div>
                <h6>{t("SchedaSpecialeTbcPolmonare.parte1A")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>
                    {datiDelCentro}
                    {datiAnagrafici}
                </div>
            </div>
        );
    }


}

export default withTranslation('common')(Parte1A)

